module.exports = __webpack_public_path__ + "static/media/companyLogo.3c8aefe2.png";